import React from 'react';
import PropTypes from 'prop-types';

import SrSimpleMessageModal, {
  SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP,
} from 'client/components/SrSimpleMessageModal/SrSimpleMessageModal';

import {
  SR_BUTTON_THEME_ADOBE_GREY,
  SR_BUTTON_THEME_ADOBE_RED,
} from 'client/components/SrButton/SrButton';
import { isHomebuyerPartner } from 'common/utility/helpers';

const SrUtilityProfitRemoveProviderModal = ({
  utilityPartner,
  onRemoveOptionConfirm,
  onRemoveOptionCancel,
}) => {
  return (
    <SrSimpleMessageModal
      iconUrl="/images/big-red-question-mark.png"
      headline={
        isHomebuyerPartner(utilityPartner)
          ? 'Remove this provider for the client?'
          : 'Remove this provider for the tenant?'
      }
      underline
      maxWidth={400}
      theme={SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP}
      srMultiButtons={[
        {
          buttonText: 'Confirm & Remove',
          onButtonClick: onRemoveOptionConfirm,
          buttonTheme: SR_BUTTON_THEME_ADOBE_RED,
        },
        {
          buttonText: 'Cancel',
          onButtonClick: onRemoveOptionCancel,
          buttonTheme: SR_BUTTON_THEME_ADOBE_GREY,
        },
      ]}
    />
  );
};

SrUtilityProfitRemoveProviderModal.propTypes = {
  utilityPartner: PropTypes.object,
  onRemoveOptionConfirm: PropTypes.func.isRequired,
  onRemoveOptionCancel: PropTypes.func.isRequired,
};

SrUtilityProfitRemoveProviderModal.displayName = 'SrUtilityProfitRemoveProviderModal';

export default SrUtilityProfitRemoveProviderModal;
